export default "__VITE_ASSET__NA9ZDqKw__"